import React, { useState } from "react";
import { toast } from "sonner";
import { Eye, Loader2 } from "lucide-react";
import { openPreview } from "../../lib/portalPreview";

/**
 * "Vezi portalul ca …" (22.10.2026): the portal as this person sees it, read
 * only, in a new tab, for 60 minutes. The person is not told.
 */
export default function PreviewButton({ target, label, iconOnly = false, testid }) {
  const [busy, setBusy] = useState(false);
  const go = async () => {
    setBusy(true);
    await openPreview(target, { onError: (m) => toast.error(m) });
    setBusy(false);
  };
  const title = `${label} (doar citire, 60 de minute)`;
  return iconOnly ? (
    <button type="button" onClick={go} disabled={busy} title={title} aria-label={title}
      className="rounded-full p-1 text-[#6B7280] hover:bg-[#F0E7F4] hover:text-[#7A4986] disabled:opacity-50" data-testid={testid}>
      {busy ? <Loader2 size={14} className="animate-spin" /> : <Eye size={14} />}
    </button>
  ) : (
    <button type="button" onClick={go} disabled={busy} title={title}
      className="inline-flex items-center gap-1.5 rounded-full border border-[#E5E7EB] bg-white px-4 py-2 text-sm font-semibold text-[#373A45] hover:border-[#965EA7] hover:text-[#965EA7] disabled:opacity-60"
      data-testid={testid}>
      {busy ? <Loader2 size={14} className="animate-spin" /> : <Eye size={14} />} {label}
    </button>
  );
}
